<template>
  <div class="content">
    <el-row>
      <el-col :span="19">
        <div>
          <p class="title">职位信息</p>
          <el-row style="line-height: 20px; margin-top: 30px">
            <el-col :span="6">
              <div>
                <el-row>
                  <el-col :span="9">岗位名称：</el-col>
                  <el-col :span="15" class="init">{{ data.jobName }}</el-col>
                </el-row>
              </div>
            </el-col>
            <el-col :span="6">
              <div>
                <el-row>
                  <el-col :span="9">招聘单位：</el-col>
                  <el-col :span="15" class="init">{{
                    data.enterpriseName
                  }}</el-col>
                </el-row>
              </div>
            </el-col>
            <el-col :span="6">
              <el-row>
                <el-col :span="9">招聘部门：</el-col>
                <el-col :span="15" class="init">{{
                  data.departmentName
                }}</el-col>
              </el-row>
            </el-col>
            <el-col :span="6">
              <el-row>
                <el-col :span="9">招聘人数：</el-col>
                <el-col :span="15" class="init">{{ data.personNum }}</el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row
            style="line-height: 20px; margin-top: 30px; margin-bottom: 20px"
          >
            <el-col :span="6">
              <div>
                <el-row>
                  <el-col :span="9">性别要求：</el-col>
                  <el-col :span="15" class="init">
                    <span v-if="data.sex == 0">不限</span>
                    <span v-if="data.sex == 'M'">男</span>
                    <span v-if="data.sex == 'F'">女</span>
                  </el-col>
                </el-row>
              </div>
            </el-col>
            <el-col :span="6">
              <div>
                <el-row>
                  <el-col :span="9">任职地点：</el-col>
                  <el-col :span="15" class="init">{{ data.workPlace }}</el-col>
                </el-row>
              </div>
            </el-col>
            <el-col :span="6">
              <el-row>
                <el-col :span="9">薪酬标准：</el-col>
                <el-col :span="15" class="init">{{
                  data.salaryFm + "~" + data.salaryTo
                }}</el-col>
              </el-row>
            </el-col>
            <el-col :span="6">
              <el-row>
                <el-col :span="9">发布日期：</el-col>
                <el-col :span="15" class="init">{{
                  moment(data.publishDate).format("YYYY-MM-DD")
                }}</el-col>
              </el-row>
            </el-col>
          </el-row>
          <div>
            <p style="font-weight: 600">岗位职责：</p>
            <div
              style="min-height: 100px; padding: 10px 0"
              v-html="data.positionInfo"
            ></div>
            <p style="font-weight: 600">任职要求：</p>
            <div
              style="min-height: 100px; padding: 10px 0"
              v-html="data.skills"
            ></div>
          </div>
          <p class="title">联系方式</p>
          <div style="padding: 20px 0">
            <el-row>
              <el-col :span="10">联系人：{{ data.linker }}</el-col>
              <el-col :span="10">联系电话：{{ data.linkTel }}</el-col>
            </el-row>
          </div>
          <p class="title">公司信息</p>
          <div style="min-height: 200px">
            <div style="padding: 10px 0">
              {{ data.organIntroduce }}
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="5" style="padding: 10px; border-left: 1px solid #ddd">
        <div>
          <ul>
            <li
              class="item"
              @click="open(item)"
              v-for="(item, index) in list"
              :key="index"
              style="cursor: pointer"
            >
              <p style="font-size: 16px; font-weight: 600; margin-bottom: 15px">
                {{ item.jobName }}
              </p>
              <p style="font-size: 16px; margin-bottom: 15px">
                {{ item.enterpriseName }}
              </p>
              <p>
                <span style="color: #f66007">{{
                  item.salaryStandard.nodeName
                }}</span>
                <span
                  style="
                    float: right;
                    width: 100px;
                    text-align: right;
                    word-wrap: break-word;
                    word-break: normal;
                  "
                  >{{ item.workPlace }}</span
                >
              </p>
              <div style="padding: 10px 0">
                <el-divider></el-divider>
              </div>
            </li>
          </ul>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { recruitJob_qy } from "@/api/home";
import moment from "moment";
import router from "@/router/index";
export default {
  data() {
    return {
      list: [],
      data: {},
      moment,
    };
  },
  mounted() {
    this.getData();
    this.getList();
    router.beforeEach((to, from, next) => {
      next();
    });
  },
  methods: {
    open(item) {
      if (item.recruitJobId == this.$route.query.recruitJobId) {
        return;
      }
      this.$router.push({
        path: "/recruitJobDetail",
        query: {
          id: this.$route.query.id,
          recruitJobId: item.recruitJobId,
        },
      });
      this.getData();
    },
    getData() {
      let vm = this;
      recruitJob_qy({
        op: "getRecruitJobById",
        recruitJobId: this.$route.query.recruitJobId,
      }).then((res) => {
        if (res.skills) {
          res.skills = res.skills.replace(/\n|\r|\\s/g, "<br/>");
        }
        if (res.positionInfo) {
          res.positionInfo = res.positionInfo.replace(/\n|\r|\\s/g, "<br/>");
        }

        vm.data = res;
      });
    },
    getList() {
      recruitJob_qy({
        op: "findPageRecruitJob",
        pageNo: 1,
        pageSize: 10,
      }).then((res) => {
        this.list = res.result;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  font-size: 14px;
  margin: 0 auto;
  margin-top: 50px;
  background: #fff;
  padding: 15px;
  .title {
    line-height: 30px;
    padding-left: 20px;
    border-left: 4px solid #f02b2b;
    font-weight: 600;
    font-size: 16px;
  }
  .init {
    word-wrap: break-word;
    word-break: normal;
    padding-right: 10px;
  }
  .item:hover {
    background: #ddd;
  }
}
</style>